export function formatBytes(bytes) {
    if (bytes === 0) return "0 B";
    if (!bytes && bytes !== 0) return "";
    const k = 1024; const sizes = ["B","KB","MB","GB","TB"]; const i = Math.floor(Math.log(bytes)/Math.log(k));
    return `${(bytes/Math.pow(k,i)).toFixed(i === 0 ? 0 : 1)} ${sizes[i]}`;
}

export function formatDateYMD(dt) {
    if (!dt) return "";
    const d = new Date(dt);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${yyyy}-${mm}-${dd}`; // matches your wireframe style
}